import React from "react";

import style from "../assets/css/components/TopGoal.module.css";

function TopGoal({ data }) {

  return (
    <>
      <div className={style.contTitle}>
        <p className={style.titleSection}>Top goleadores</p>
      </div>
      <div className={style.contList}>
        {data &&
          data.map((player, index) => (
            <Item
              key={index}
              pos={index + 1}
              player={`${player.name} ${player.app}`}
              team={player.team.name}
              goal={player.goal}
            />
          ))}
      </div>
    </>
  );
}

const Item = ({ pos, player, team, goal }) => (
  <div className={style.contItem}>
    <div className={style.position}>
      <p className={style.number}>{pos}</p>
    </div>
    <div className={style.player}>
      <p className={style.name}>{player}</p>
      <p className={style.team}>{team}</p>
    </div>
    <div className={style.score}>
      <div className={style.contNumber}>
        <p className={style.number}>{goal}</p>
      </div>
    </div>
  </div>
);

export default TopGoal;
